/* Elite custom start: preserve an explicit subscription choice when Eurus changes variants. */
(() => {
  if (window.eliteSubscriptionChoiceLoaded) return;
  window.eliteSubscriptionChoiceLoaded = true;
  function init() {
    const block = document.querySelector('.shopify_subscriptions_app_block');
    const root = block?.closest('[id^="ProductInfo-"]');
    if (!root || root.dataset.eliteSubscriptionChoice) return;
    root.dataset.eliteSubscriptionChoice = 'true';
    let chosen = null, restoring = false, queued = false;
    root.addEventListener('change', (event) => {
      const input = event.target;
      if (restoring || !input.matches('input[data-radio-type]')) return;
      chosen = input.dataset.sellingPlanId || '';
    });
    const restore = () => {
      queued = false;
      if (chosen === null) return;
      const section = Array.from(root.querySelectorAll('.shopify_subscriptions_app_block')).find(el => el.getBoundingClientRect().height > 0);
      if (!section) return;
      const input = Array.from(section.querySelectorAll('input[data-radio-type]')).find(el => (el.dataset.sellingPlanId || '') === chosen);
      if (input && !input.checked) {
        restoring = true;
        input.click();
        restoring = false;
      }
    };
    new MutationObserver(() => {
      if (!queued) { queued = true; requestAnimationFrame(restore); }
    }).observe(root, {subtree:true, childList:true, attributes:true, attributeFilter:['class','style']});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
/* Elite custom end */
